import { optional } from '@/helpers/dto2resource';
import DetalhesPropostaDto from '@/models/dto/DetalhesPropostaDto';

class DetalhesPropostaResource {
  bloqueio: boolean;
  descricao?: string;
  giftCardElegivel?: boolean;

  constructor(dto: DetalhesPropostaDto) {
    this.bloqueio = dto.bloqueio ?? false;
    this.descricao = dto.descricao ?? undefined;
    this.giftCardElegivel = optional(dto.giftCardElegivel);
  }

  static fromWhiteLabel(dto: string) {
    const detalhes = new DetalhesPropostaResource({});
    detalhes.descricao = dto;
    return detalhes;
  }
}

export default DetalhesPropostaResource;
